













































import { Component, Vue } from 'vue-property-decorator';
import { AddressModel, DataStore } from 'vue-thailand-address';

type AddressData = {
	store: DataStore;
	model: AddressModel;
};

const createEmptyAddress = (): AddressModel =>
	({
		subdistrict: '',
		district: '',
		province: '',
		zipcode: ''
	} as AddressModel);

@Component({
	name: 'Demo'
})
export default class Demo extends Vue {
	addresses: AddressData[] = [
		{
			store: new DataStore(),
			model: createEmptyAddress()
		}
	];

	add() {
		this.addresses.push({
			store: new DataStore(),
			model: createEmptyAddress()
		});
	}
	remove(index: number) {
		this.addresses.splice(index, 1);
	}
}
